import { isEmpty } from "ramda";
import { TEMPLATE_CLIENT as templateClient } from "../common";

const state = {
  templates: [],
  fetchedOn: 0,
  revisions: {},
};

const getters = {
  getTemplates: (state) => state.templates,
  getTemplate: (state) => (templateId, revision) =>
    state.templates.find(
      (t) =>
        t.id === templateId &&
        (t.revision === revision || t.revision === parseInt(revision))
    ),
  templatesFetchedOn: (state) => state.fetchedOn,
  getRevisions: (state) => (templateId) => state.revisions[templateId],
  getLatestRevision: (state) => {
    return (templateId) => {
      const revisions = state.revisions[templateId];
      if (!revisions) {
        return undefined;
      }

      const latestRevision = Math.max(...revisions.map((rev) => rev.revision));
      return revisions.find((rev) => rev.revision === latestRevision);
    };
  },
};

const mutations = {
  SET_TEMPLATES(state, templates) {
    state.templates = templates;
    state.fetchedOn = Date.now();
  },
  SET_TEMPLATE(state, template) {
    const templateExists = state.templates.filter(
      (t) => t.id === template.id && t.revision === template.revision
    );

    if (isEmpty(templateExists)) {
      state.templates.push(template);
    }
  },
  SET_TEMPLATE_REVISIONS(state, { revisions, templateId }) {
    state.revisions[templateId] = revisions;
  },
};

const actions = {
  async fetchTemplates({ commit, rootGetters, dispatch }) {
    await dispatch("auth/checkUserSession", {}, { root: true });
    const params = { revision: "latest" };

    const jwtToken = rootGetters["auth/getIdentityToken"];

    const response = await templateClient.get(`/`, {
      params,
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    commit("SET_TEMPLATES", response.data);
  },
  async fetchTemplate({ commit, rootGetters, dispatch }, { templateId, revision }) {
    const params = {};
    if (revision) {
      params["revision"] = revision;
    }

    await dispatch("auth/checkUserSession", {}, { root: true });
    const jwtToken = rootGetters["auth/getIdentityToken"];

    const response = await templateClient.get(`/${templateId}`, {
      params,
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    commit("SET_TEMPLATE", response.data);
  },
  async fetchRevisions({ commit, rootGetters, dispatch }, { templateId }) {
    await dispatch("auth/checkUserSession", {}, { root: true });
    const jwtToken = rootGetters["auth/getIdentityToken"];

    const response = await templateClient.get(`/${templateId}`, {
      headers: { Authorization: `Bearer ${jwtToken}` },
    });
    commit("SET_TEMPLATE_REVISIONS", { revisions: response.data, templateId });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
